// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-cookie-declaration-js": () => import("./../../../src/pages/cookie-declaration.js" /* webpackChunkName: "component---src-pages-cookie-declaration-js" */),
  "component---src-templates-building-js": () => import("./../../../src/templates/building.js" /* webpackChunkName: "component---src-templates-building-js" */)
}

